<template>
  <mobile-status-section
    :statuses="statuses"
    :records="records"
    show-next-contact
  ></mobile-status-section>
</template>

<script>
import MobileStatusSection from "../../components/MobileStatusSection";

export default {
  name: "ContactingPipelineMobile",
  components: {MobileStatusSection},
  data() {
    return {
      pageLoading: false,
    };
  },
  computed: {
    statuses() {
      return this.$store.getters["pipeline/contactingStatusesInView"];
    },
    records() {
      return this.$store.getters["contactingState/records"]
    }
  },
  created() {
    this.$store.dispatch("contactingState/setup", {useLazyLoader: false}).then(() => {
      this.pageLoading = false;
    });
  },
  destroyed() {
    this.$store.dispatch("contactingState/tearDown");
  },
};
</script>
